export const LogoMark = ({ className = "w-10 h-10", dark = false }) => (
  <svg viewBox="0 0 48 48" className={className} aria-hidden="true" role="img">
    <circle cx="24" cy="24" r="22" fill={dark ? "none" : "#0B192C"} stroke="#D97706" strokeWidth="1.6" />
    <path d="M24 7 L28.2 19.8 L41 24 L28.2 28.2 L24 41 L19.8 28.2 L7 24 L19.8 19.8 Z" fill="#D97706" />
    <circle cx="24" cy="24" r="2.4" fill="#0B192C" />
  </svg>
);
